export default function KaiViewCount({ isAdmin, className, label, children }) {
  if (!isAdmin) return null;

  return (
    <span className={className} aria-label={label}>
      {children}
    </span>
  );
}
